import React from "react";
const NoAttributeProvided = () => /* @__PURE__ */ React.createElement("i", null, "Not provided");
export default NoAttributeProvided;
